import { render } from "./facebook-icon.vue?vue&type=template&id=755f623c"
import script from "./facebook-icon.vue?vue&type=script&lang=js"
export * from "./facebook-icon.vue?vue&type=script&lang=js"

import "./facebook-icon.vue?vue&type=style&index=0&id=755f623c&lang=css"
script.render = render

export default script